import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import baseMessage from '@/views/yuntuSales/marketing/partnerManage/components/baseMessage.vue'

const __default__ = { name: 'DcCosLbuPartnerManageEdit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permissionBase = {
  save: 'lbu_partner_edit_btn'
}

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(baseMessage, {
            disabled: false,
            permissionPage: permissionBase
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})